import { Assets, Sprite } from 'pixi.js';

import assertDefined from 'app/utils/assert-defined';
import { getResizeUri } from 'app/utils/image';
import SocialArtifact from 'entity/SocialArtifact';

export const getArtifactInfo = (
  a: SocialArtifact,
  ratio: number,
): { height: number; width: number; imageURI: string; x: number; y: number; artifactId: number } => {
  assertDefined(a.imageURI);
  const height = (a.height ?? 0) * ratio;
  const width = (a.width ?? 0) * ratio;
  const imageURI = getResizeUri({ uri: a.imageURI, height, width });
  const x = a.x ?? 0;
  const y = a.y ?? 0;
  const artifactId = a.artifactId ?? Date.now();
  return { height, width, imageURI, x, y, artifactId };
};

export const createArtifactSprite = (
  artifact: SocialArtifact,
  ratio: number,
  compressed: boolean,
): Promise<Sprite | null> => {
  return new Promise(async (resolve): Promise<void> => {
    if (!artifact.artifactId || !artifact.imageURI) {
      resolve(null);
      return;
    }
    const artifactAsset = await Assets.load(
      (compressed ? artifact.imageURI?.replace('webp', 'ktx2') : artifact.imageURI) ?? '',
    );
    const { artifactId, height, width, x, y } = getArtifactInfo(artifact, ratio);
    const sprite = Sprite.from(artifactAsset);
    sprite.name = `${artifactId}`;
    sprite.width = width;
    sprite.height = height;
    sprite.position.set(x, y);
    sprite.anchor.set(0.5, 0.5);
    resolve(sprite);
  });
};
